import { render, staticRenderFns } from "./QuickItemDetail.vue?vue&type=template&id=99ab6faa&scoped=true"
import script from "./QuickItemDetail.vue?vue&type=script&lang=js"
export * from "./QuickItemDetail.vue?vue&type=script&lang=js"
import style0 from "./QuickItemDetail.vue?vue&type=style&index=0&id=99ab6faa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ab6faa",
  null
  
)

export default component.exports